import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { DamagedListTable } from 'src/components/Table/list/Damaged'
import { ListPage } from 'src/components/Pages/ListPage'

export const DamagedListPage = () => {
  const paginator = useQueryPaginator('damaged-list', skuit.sc.damaged.list)

  const exportFields = [
    'asn_guid',
    'asn_tracking_number',
    'client_guid',
    'client_name',
    'damage_reason',
    'damaged_on',
    'facility',
    'facility_guid',
    'guid',
    'notes',
    'path',
    'product_guid',
    'product_name',
    'sku',
    'sku_guid',
  ]

  return (
    <ListPage
      title='Damages'
      paginator={paginator}
    >
      <DamagedListTable
        paginator={paginator}
        fields={['guid', 'client', 'damagedOn', 'sku', 'product', 'batch', 'path']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.damaged.export
        }}
      />
    </ListPage>
  )
}
